import { setTemplateEngine, getTemplateEngine } from '@syncfusion/ej2-base';
import { setValue, getValue } from '@syncfusion/ej2-base';
const stringCompiler = getTemplateEngine();
/**
 * Angular Template Compiler
 *
 * @param {AngularElementType} templateEle - The element representing the template.
 * @param {Object} [helper] - Optional helper object.
 * @returns {Function} A function that compiles the template.
 */
export function compile(templateEle, helper) {
    if (typeof templateEle === 'string' || (typeof templateEle === 'function' && templateEle.prototype && templateEle.prototype.CSPTemplate)) {
        return stringCompiler(templateEle, helper);
    }
    else {
        const contRef = templateEle.elementRef.nativeElement._viewContainerRef;
        const pName = templateEle.elementRef.nativeElement.propName;
        return (data, component, propName) => {
            const context = { $implicit: data };
            /* istanbul ignore next */
            const conRef = contRef ? contRef : component.viewContainerRef;
            const viewRef = conRef.createEmbeddedView(templateEle, context);
            if (/EJS-MENTION|EJS-DROPDOWNLIST/.test(getValue('currentInstance.element.nodeName', conRef)) ||
                (/E-TABITEM/.test(getValue('element.nativeElement.nodeName', conRef)) &&
                    getValue('currentInstance.headerTemplateRef', conRef))) {
                viewRef.detectChanges();
            }
            else {
                viewRef.markForCheck();
            }
            /* istanbul ignore next */
            const viewCollection = (component && component.registeredTemplate) ?
                component.registeredTemplate : getValue('currentInstance.registeredTemplate', conRef);
            propName = (propName && component.registeredTemplate) ? propName : pName;
            if (typeof viewCollection[`${propName}`] === 'undefined') {
                viewCollection[`${propName}`] = [];
            }
            viewCollection[`${propName}`].push(viewRef);
            return viewRef.rootNodes;
        };
    }
}
/**
 * Property decorator for angular.
 *
 * @param {Object} [defaultValue] - Default value for the property.
 * @returns {PropertyDecorator} The decorator function.
 */
export function Template(defaultValue) {
    return (target, key) => {
        const propertyDescriptor = {
            set: setter(key),
            get: getter(key, defaultValue),
            enumerable: true,
            configurable: true
        };
        Object.defineProperty(target, key, propertyDescriptor);
    };
}
/**
 * Creates a setter function for a given property key.
 *
 * @param {string} key - The property key.
 * @returns {Function} The setter function.
 */
function setter(key) {
    return function (val) {
        if (val === undefined) {
            return;
        }
        setValue(key + 'Ref', val, this);
        if (typeof val !== 'string' && !(typeof val === 'function' && val.prototype && val.prototype.CSPTemplate)) {
            val.elementRef.nativeElement._viewContainerRef = this.viewContainerRef;
            val.elementRef.nativeElement.propName = key;
        }
        else {
            if (this.saveChanges) {
                this.saveChanges(key, val, undefined);
                this.dataBind();
            }
        }
    };
}
/**
 * Returns a getter function for the specified key and default value.
 *
 * @param {string} key - The key for the property.
 * @param {Object} defaultValue - The default value for the property.
 * @returns {Function} The getter function.
 */
function getter(key, defaultValue) {
    return function () {
        /* istanbul ignore next */
        return getValue(key + 'Ref', this) || defaultValue;
    };
}
setTemplateEngine({ compile: compile });
